function initStretch() {
    const stretch = document.querySelector('.js-header-stretch');
    const closeButton = document.querySelector('.js-stretch-close');

    if (!stretch || !closeButton) {
        return false;
    }

    $(stretch).slideDown(300, () => {
        document.dispatchEvent(new Event('header:update'));
    });

    closeButton.addEventListener('click', () => {
        $(stretch).slideUp(300, () => {
            document.dispatchEvent(new Event('header:update'));
        });

        setTimeout(() => {
            $(stretch).slideDown(300, () => {
                document.dispatchEvent(new Event('header:update'));
            });
        }, 25000)
    })
}
